var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_12263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0V0Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 5.46387L5.82227 6.05646L6.11856 6.11572L6.00004 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 5.46387L6.17773 6.05646L5.88144 6.11572L5.99996 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56373 5.87318L5.9452 5.88722L5.9804 6.18733L6.56373 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56323 5.8734L6.05457 6.2256L5.90666 5.96212L6.56323 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34836 6.53565L6.14387 5.95174L5.86933 6.07795L6.34836 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34793 6.53564L5.85578 6.16072L6.06066 5.93862L6.34793 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43725 5.87318L6.05578 5.88722L6.02057 6.18733L5.43725 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43775 5.8734L5.9464 6.2256L6.09432 5.96212L5.43775 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65261 6.53565L5.85711 5.95174L6.13165 6.07795L5.65261 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65305 6.53564L6.14519 6.16072L5.94032 5.93862L5.65305 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 5.46387L5.82227 6.05646L6.11856 6.11572L6.00004 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 5.46387L6.17773 6.05646L5.88144 6.11572L5.99996 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56373 5.87318L5.9452 5.88722L5.9804 6.18733L6.56373 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56323 5.8734L6.05457 6.2256L5.90666 5.96212L6.56323 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34836 6.53565L6.14387 5.95174L5.86933 6.07795L6.34836 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34793 6.53564L5.85578 6.16072L6.06066 5.93862L6.34793 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43725 5.87318L6.05578 5.88722L6.02057 6.18733L5.43725 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43775 5.8734L5.9464 6.2256L6.09432 5.96212L5.43775 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65261 6.53565L5.85711 5.95174L6.13165 6.07795L5.65261 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65305 6.53564L6.14519 6.16072L5.94032 5.93862L5.65305 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 5.46387L5.82227 6.05646L6.11856 6.11572L6.00004 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 5.46387L6.17773 6.05646L5.88144 6.11572L5.99996 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56373 5.87318L5.9452 5.88722L5.9804 6.18733L6.56373 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56323 5.8734L6.05457 6.2256L5.90666 5.96212L6.56323 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34836 6.53565L6.14387 5.95174L5.86933 6.07795L6.34836 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34793 6.53564L5.85578 6.16072L6.06066 5.93862L6.34793 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43725 5.87318L6.05578 5.88722L6.02057 6.18733L5.43725 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43775 5.8734L5.9464 6.2256L6.09432 5.96212L5.43775 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65261 6.53565L5.85711 5.95174L6.13165 6.07795L5.65261 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65305 6.53564L6.14519 6.16072L5.94032 5.93862L5.65305 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9177 3.4834L4.40984 3.10847L4.20496 2.88637L3.9177 3.4834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91824 3.4834L4.12273 2.89949L4.39727 3.02571L3.91824 3.4834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70337 2.82116L4.21203 3.17336L4.35995 2.90987L3.70337 2.82116Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70385 2.82142L4.32238 2.83546L4.28718 3.13557L3.70385 2.82142Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26665 2.41162L4.08887 3.00421L4.38516 3.06347L4.26665 2.41162Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26656 2.41162L4.44434 3.00421L4.14804 3.06347L4.26656 2.41162Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61453 3.48388L4.12239 3.10896L4.32726 2.88686L4.61453 3.48388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61399 3.4834L4.4095 2.89949L4.13495 3.02571L4.61399 3.4834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82983 2.82116L4.32118 3.17336L4.17326 2.90987L4.82983 2.82116Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82935 2.82093L4.21082 2.83498L4.24603 3.13508L4.82935 2.82093Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2966 4.80176L3.09211 4.21785L2.81757 4.34406L3.2966 4.80176Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29617 4.80175L2.80403 4.42683L3.0089 4.20473L3.29617 4.80175Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60032 4.80224L3.09246 4.42732L2.88758 4.20522L2.60032 4.80224Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60086 4.80225L2.80535 4.21834L3.07989 4.34455L2.60086 4.80225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38501 4.13952L2.89367 4.49171L3.04159 4.22823L2.38501 4.13952Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38549 4.13929L3.00402 4.15334L2.96882 4.45344L2.38549 4.13929Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51147 4.13903L3.00282 4.49123L2.8549 4.22774L3.51147 4.13903Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51197 4.13929L2.89344 4.15334L2.92864 4.45344L3.51197 4.13929Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9482 3.72998L3.12598 4.32257L2.82968 4.38183L2.9482 3.72998Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94829 3.72998L2.77051 4.32257L3.0668 4.38183L2.94829 3.72998Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51294 7.70326L2.89442 7.7173L2.92962 8.01741L3.51294 7.70326Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51245 7.70348L3.00379 8.05568L2.85587 7.7922L3.51245 7.70348Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29758 8.36621L3.09309 7.7823L2.81855 7.90852L3.29758 8.36621Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29715 8.36621L2.805 7.99129L3.00988 7.76919L3.29715 8.36621Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60129 8.36621L3.09343 7.99129L2.88856 7.76919L2.60129 8.36621Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60183 8.36573L2.80632 7.78181L3.08087 7.90803L2.60183 8.36573Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94918 7.29395L3.12695 7.88654L2.83066 7.9458L2.94918 7.29395Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94926 7.29395L2.77148 7.88654L3.06778 7.9458L2.94926 7.29395Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38549 7.70326L3.00402 7.7173L2.96882 8.01741L2.38549 7.70326Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38599 7.70348L2.89464 8.05568L3.04256 7.7922L2.38599 7.70348Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79908 8.89613L4.18055 8.91017L4.21575 9.21028L4.79908 8.89613Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79858 8.89635L4.28993 9.24855L4.14201 8.98507L4.79858 8.89635Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58371 9.5586L4.37922 8.97468L4.10468 9.1009L4.58371 9.5586Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58328 9.55859L4.09114 9.18367L4.29601 8.96157L4.58328 9.55859Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88742 9.55859L4.37957 9.18367L4.17469 8.96157L3.88742 9.55859Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88797 9.55811L4.09246 8.9742L4.367 9.10041L3.88797 9.55811Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23531 8.48682L4.41309 9.07941L4.11679 9.13867L4.23531 8.48682Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23539 8.48682L4.05762 9.07941L4.35391 9.13867L4.23539 8.48682Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67163 8.89613L4.29015 8.91017L4.25495 9.21028L3.67163 8.89613Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67212 8.89635L4.18078 9.24855L4.3287 8.98507L3.67212 8.89635Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00093 5.46387L6.17871 6.05646L5.88241 6.11572L6.00093 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00102 5.46387L5.82324 6.05646L6.11954 6.11572L6.00102 5.46387Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43725 5.87318L6.05578 5.88722L6.02057 6.18733L5.43725 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43775 5.8734L5.9464 6.2256L6.09432 5.96212L5.43775 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65261 6.53565L5.85711 5.95174L6.13165 6.07795L5.65261 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65305 6.53564L6.14519 6.16072L5.94032 5.93862L5.65305 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5647 5.87318L5.94618 5.88722L5.98138 6.18733L6.5647 5.87318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5642 5.8734L6.05555 6.2256L5.90763 5.96212L6.5642 5.8734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34836 6.53565L6.14387 5.95173L5.86933 6.07795L6.34836 6.53565Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34793 6.53564L5.85578 6.16072L6.06066 5.93862L6.34793 6.53564Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08328 3.48388L7.59114 3.10896L7.79601 2.88686L8.08328 3.48388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08274 3.48389L7.87825 2.89998L7.6037 3.02619L8.08274 3.48389Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2976 2.82116L7.78895 3.17336L7.64103 2.90987L8.2976 2.82116Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29712 2.82142L7.6786 2.83546L7.7138 3.13557L8.29712 2.82142Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73433 2.41162L7.91211 3.00421L7.61581 3.06347L7.73433 2.41162Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73442 2.41162L7.55664 3.00421L7.85294 3.06347L7.73442 2.41162Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38645 3.48388L7.87859 3.10896L7.67371 2.88686L7.38645 3.48388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38699 3.4834L7.59148 2.89949L7.86602 3.02571L7.38699 3.4834Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17115 2.82067L7.6798 3.17287L7.82772 2.90938L7.17115 2.82067Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17163 2.82093L7.79015 2.83498L7.75495 3.13508L7.17163 2.82093Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70437 4.80127L8.90886 4.21736L9.18341 4.34358L8.70437 4.80127Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70481 4.80127L9.19695 4.42634L8.99207 4.20424L8.70481 4.80127Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40066 4.80127L8.90852 4.42634L9.1134 4.20424L9.40066 4.80127Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40012 4.80127L9.19563 4.21736L8.92109 4.34358L9.40012 4.80127Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61596 4.13854L9.10731 4.49074L8.95939 4.22726L9.61596 4.13854Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61548 4.13831L8.99696 4.15236L9.03216 4.45247L9.61548 4.13831Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48951 4.13854L8.99816 4.49074L9.14608 4.22726L8.48951 4.13854Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48901 4.1388L9.10753 4.15285L9.07233 4.45295L8.48901 4.1388Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05278 3.72949L8.875 4.32208L9.1713 4.38134L9.05278 3.72949Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05269 3.72949L9.23047 4.32208L8.93417 4.38134L9.05269 3.72949Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48803 7.70326L9.10656 7.7173L9.07136 8.01741L8.48803 7.70326Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48853 7.70348L8.99718 8.05568L9.1451 7.7922L8.48853 7.70348Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7034 8.36573L8.90789 7.78181L9.18243 7.90803L8.7034 8.36573Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70383 8.36572L9.19597 7.9908L8.9911 7.7687L8.70383 8.36572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39968 8.36572L8.90754 7.9908L9.11242 7.7687L9.39968 8.36572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39914 8.36573L9.19465 7.78181L8.92011 7.90803L9.39914 8.36573Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0518 7.29395L8.87402 7.88654L9.17032 7.9458L9.0518 7.29395Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05171 7.29395L9.22949 7.88654L8.9332 7.9458L9.05171 7.29395Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61548 7.70326L8.99696 7.7173L9.03216 8.01741L9.61548 7.70326Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61499 7.70348L9.10633 8.05568L8.95841 7.7922L9.61499 7.70348Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2019 8.89613L7.82042 8.91017L7.78522 9.21028L7.2019 8.89613Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2024 8.89635L7.71105 9.24855L7.85897 8.98507L7.2024 8.89635Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41726 9.5586L7.62175 8.97468L7.8963 9.1009L7.41726 9.5586Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4177 9.55859L7.90984 9.18367L7.70496 8.96157L7.4177 9.55859Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11355 9.55859L7.62141 9.18367L7.82629 8.96157L8.11355 9.55859Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11301 9.5586L7.90852 8.97468L7.63398 9.1009L8.11301 9.5586Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76567 8.48633L7.58789 9.07892L7.88419 9.13818L7.76567 8.48633Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76558 8.48633L7.94336 9.07892L7.64706 9.13818L7.76558 8.48633Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32935 8.89613L7.71083 8.91017L7.74603 9.21028L8.32935 8.89613Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32885 8.89635L7.8202 9.24855L7.67228 8.98507L8.32885 8.89635Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_12263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.c93784fde79960fd037d1bcc0c220f3d.svg";
export { ForwardRef as ReactComponent };